import { render, staticRenderFns } from "./BottomButton.vue?vue&type=template&id=4b1d5b27"
import script from "./BottomButton.vue?vue&type=script&lang=js"
export * from "./BottomButton.vue?vue&type=script&lang=js"
import style0 from "./BottomButton.vue?vue&type=style&index=0&id=4b1d5b27&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports